import React from "react";
import CookieCleaner from "./CookieCleaner";
import Button from "@utdanningsdirektoratet/udir-gui/lib/elements/button/Button";
class DialogCookieCleaner extends React.Component {
    constructor(props) {
        super(props);
        this.renderCollapsed = this.renderCollapsed.bind(this);
        this.renderExpanded = this.renderExpanded.bind(this);
        this.state = {
            collapsed: true
        };
    }
    renderCollapsed() {
        return (React.createElement(Button, { style: "link", onClick: () => this.setState({ collapsed: false }) }, "Les mer"));
    }
    renderExpanded() {
        return (React.createElement("div", null,
            React.createElement("div", { className: "block-2-bottom" }, this.props.expandedContent),
            React.createElement(CookieCleaner, { label: this.props.cleanLinkLabel, buttonStyle: { style: "link" }, onSuccess: this.props.onCookieClean })));
    }
    render() {
        return (React.createElement("div", { className: "gui-dialogCookieCleaner" },
            React.createElement("h2", { className: "h4" }, "Vedvarer feilen?"),
            this.state.collapsed ? this.renderCollapsed() : this.renderExpanded()));
    }
}
DialogCookieCleaner.defaultProps = {
    logoutMode: true
};
export default DialogCookieCleaner;
//# sourceMappingURL=DialogCookieCleaner.js.map